module.exports = __webpack_public_path__ + "img/11_TAMARIN_INDE.1e266fcd.jpg";